import styled from 'styled-components';
import { FallbackProps } from 'react-error-boundary';
import { Button } from './Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${({ theme }) => theme.spacing['2xl']};
  text-align: center;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.error};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Message = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  max-width: 500px;
`;

export const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <Container>
      <Title>Something went wrong</Title>
      <Message>{error.message || 'An unexpected error occurred'}</Message>
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </Container>
  );
};
